import RestService from "./rest.service";

class newsService {
  news() {
    return new Promise((fnResolve, fnReject) => {
      RestService.getNews("app/kpi/home/news").then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  tags(tag) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getTags(`app/kpi/home/news?tag=${tag}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  tagsList() {
    return new Promise((fnResolve, fnReject) => {
      RestService.getTagsList(`app/kpi/home/news/tag`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  limit() {
    return new Promise((fnResolve, fnReject) => {
      RestService.getNews("app/kpi/home/news?limit=4&show_home=true").then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  content(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getContentNews(`app/kpi/home/news/${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
}



export default new newsService();
